import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoadingController, ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import * as moment from 'moment';
import { HttpParams, HttpClient } from '@angular/common/http';
import { AdvancedAnalyticsServices } from '../advanced-analytics-services';
import { Globals } from '../../../globals';
import { Color } from 'ng2-charts';
import firebase from 'firebase';
import { FormBuilder, Validators } from '@angular/forms';
import { ConfigurationRoomsPage } from '../../configuration/configuration-rooms/configuration-rooms';

/**
 * Generated class for the AnalyticsRealtimePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-analytics-realtime',
  templateUrl: 'analytics-realtime.html',
})
export class AnalyticsRealtimePage {
  rtDate1 = moment().subtract(12, 'hours').format('YYYY-MM-DDTHH:mm:ss');
  rtDate2 = moment().format('YYYY-MM-DDTHH:mm:ss');
  //
  total_persons_served = 0;
  total_diners_occupied = 0;
  percentage_occupied = 0;
  sales_total = 0;
  sales_avg = 0;
  sales_ticket_sale_max = 0;
  sales_ticket_sale_min = 0;
  tickets_total = 0;
  total_amount_takeaways = 0;
  total_takeaways = 0;
  total_amount_deliveries = 0;
  total_deliveries = 0;
  total_amount_domicilio = 0;
  total_domicilio = 0;
  chartDataElements = []
  chartDataElements_ = []
  chartLabelsElements = [];
  chartCheckElements = false;
  chartDataCustomers = []
  chartDataCustomers_ = []
  chartLabelsCustomers = [];
  chartCheckCustomers = false;
  tables_occupied_customers = 0;
  tables_ticket_customers = 0;
  tables_sale_customers = 0;
  sales_per_type = [];
  tips_per_type = [];
  tips_total = 0;

  myAnalyticsData: any;

  firestore;

  analytics_occupancy_persons: any;
  analytics_occupancy_personsForm: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public translate: TranslateService,
    public http: HttpClient,
    public advancedAnalyticsServices: AdvancedAnalyticsServices,
    public modalCtrl: ModalController,
    public toastCtrl: ToastController,
    public fb: FormBuilder) {

    this.firestore = firebase.firestore();
    this.analytics_occupancy_persons = this.globals.restaurant.analytics_occupancy_persons;
    this.analytics_occupancy_personsForm = this.fb.group({
      analytics_occupancy_persons: ['', [Validators.required, Validators.pattern("[a-z0-9.-]{1,}")]],
    });

    this.getAnalyticsRealtime();
  }
  openConfiguration() {
    this.navCtrl.push(ConfigurationRoomsPage);
  }

  async check() {
    //Comprovamos limites de la licencia
    if (this.analytics_occupancy_personsForm.valid) {
      this.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'analytics_occupancy_persons': this.analytics_occupancy_persons,
      });
      //toast
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-guardado-correctamente'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
      this.getAnalyticsData();
    }

  }

  async getAnalyticsData() {
    //get data
    this.getDinersServed();
    this.getOccupation();
    this.getSales();
    this.getTakeaways();
    this.getTop5Elements();
    this.getTop5Customers();
    this.getCustomers();
  }

  async getAnalyticsRealtime() {
    //set date hour
    this.rtDate1 = moment().subtract(6, 'hours').format('YYYY-MM-DDTHH:mm:ss');
    this.rtDate2 = moment().format('YYYY-MM-DDTHH:mm:ss');

    //tarda 4 (poca info) segundos en cargar todo
    //tirar la primera vez
    this.getAnalyticsData();
    //cada 10 segundos se actualiza la info
    this.myAnalyticsData = setInterval(() => {
      this.getAnalyticsData();
    }, 30000);
  }

  //cuando cierra la pagina
  ionViewWillLeave() {
    //parar de actualizar
    clearInterval(this.myAnalyticsData);
  }

  async getDinersServed() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.rtDate1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.rtDate2).format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/realtime24h_diners', params, {})
      .subscribe(async response => {
        this.total_persons_served = response['total_persons_served'];
      });
  }

  async getOccupation() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.rtDate1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.rtDate2).format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/realtime24h_occupation', params, {})
      .subscribe(async response => {
        this.total_diners_occupied = response['total_diners_occupied'];
        this.percentage_occupied = response['percentage_occupied'];
      });
  }

  async getSales() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.rtDate1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.rtDate2).format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/realtime24h_sales', params, {})
      .subscribe(async response => {
        this.sales_total = response['total'];
        this.sales_avg = response['avg'];
        this.sales_ticket_sale_max = response['ticket_sale_max'];
        this.sales_ticket_sale_min = response['ticket_sale_min'];
        this.tickets_total = response['total_tickets'];
        this.sales_per_type = response['sales_per_type'];
        this.tips_per_type = response['tips_per_type'];
        this.tips_total = response['tips'];
      });
  }

  async getTakeaways() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.rtDate1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.rtDate2).format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/realtime24h_takeaways', params, {})
      .subscribe(async response => {
        this.total_amount_takeaways = response['total_amount_takeaways'];
        this.total_takeaways = response['total_takeaways'];
        this.total_amount_deliveries = response['total_amount_deliveries'];
        this.total_deliveries = response['total_deliveries'];
        this.total_amount_domicilio = response['total_amount_domicilio'];
        this.total_domicilio = response['total_domicilio'];
      });
  }

  async getTop5Elements() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.rtDate1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.rtDate2).format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/realtime24h_top5_elements', params, {})
      .subscribe(async response => {
        var _labels = response['data_elements']['labels'];
        for (var index_labels in _labels) {
          _labels[index_labels] = this.globals.cutString(_labels[index_labels], 32);
        }

        this.chartDataElements_ = [];
        for (var index in this.chartDataElements) {
          this.chartDataElements_.push(this.chartDataElements[index]);
        }

        let a = JSON.stringify(response['data_elements']['data'])
        let b = JSON.stringify(this.chartDataElements_)

        if (a !== b) {

          this.chartDataElements = response['data_elements']['data'];
          this.chartLabelsElements = _labels;//response['data_elements']['labels'];

          this.chartCheckElements = false;
          await this.globals.delay(300);
        }

        this.chartCheckElements = true;

      });
  }

  async getTop5Customers() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.rtDate1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.rtDate2).format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/realtime24h_top5_customers', params, {})
      .subscribe(async response => {

        var _labels = response['data_customers']['labels'];
        for (var index_labels in _labels) {
          _labels[index_labels] = this.globals.cutString(_labels[index_labels], 32);
        }

        this.chartDataCustomers_ = [];
        for (var index in this.chartDataCustomers) {
          this.chartDataCustomers_.push(this.chartDataCustomers[index]);
        }

        let a = JSON.stringify(response['data_customers']['data'])
        let b = JSON.stringify(this.chartDataCustomers_)

        if (a !== b) {
          this.chartDataCustomers = response['data_customers']['data'];
          this.chartLabelsCustomers = _labels;//response['data_customers']['labels'];

          this.chartCheckCustomers = false;
          await this.globals.delay(300);
        }

        this.chartCheckCustomers = true;
      });
  }

  async getCustomers() {
    const params = new HttpParams()
      .set('public_key', this.globals.public_key)
      .set('first_date', moment(this.rtDate1).format('YYYY-MM-DD HH:mm:ss'))
      .set('last_date', moment(this.rtDate2).format('YYYY-MM-DD HH:mm:ss'));

    this.http.post(this.globals.analytics_path + 'analytics/realtime24h_customers', params, {})
      .subscribe(async response => {
        this.tables_occupied_customers = response['tables_occupied_customers'];
        this.tables_ticket_customers = response['tables_ticket_customers'];
        this.tables_sale_customers = response['tables_sale_customers'];
      });
  }

  public chartSalesOptions: any = {
    legend: {
      display: false,
      position: 'top',
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [{
        gridLines: {
          display: false
        }

      }],
      yAxes: [{
        gridLines: {
          display: false
        }
      }]
    },

  };
  public lineChartColors: Color[] = [
    {
      backgroundColor: 'transparent',
      borderColor: 'orange',
      pointBackgroundColor: 'orange',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];

  public RadarChartColors: Color[] = [
    {
      backgroundColor: [
        '#F8CFA9',
        '#FFB673',
        '#F8AD6D',
        '#FF7500',
        '#D76B00',
        '#BE5400',
        '#9D4815',
        '#EFD19F',
        '#EFBE7D',
        '#ECA154',
        '#E87722',
        '#CB6015',
        '#A1561C',
        '#603D20',
        '#FFAE62',
        '#FF8F1C',
        '#FF6900',
        '#FE5000',
        '#B94700',
        '#94450B',
        '#653819',
        '#FFB990',
        '#FFA06A',
        '#FF7F32',
        '#FF6A13',
        '#D86018',
        '#A65523',
        '#8B4720',
        '#FAAA8D',
        '#FA9370',
        '#F87C56',
        '#FF8A3D',
        '#F4633A',
        '#EE5340',
        '#EB3300',
        '#FFBE9F',
        '#FF9D6E',
        '#FF7F41',
        '#FF671F',
        '#E35205',
        '#BE531C',
        '#73381D',
        '#DB864E',
        '#E07E3C',
        '#DC6B2F',
        '#DC582A',
        '#C05131',
        '#864A33',
        '#674763',
        '#FFA38B',
        '#FF8D6D',
        '#FF6A39',
        '#FC4C02',
        '#DC4405',
        '#A9431E',
        '#833921',
        '#FFB3AB',
        '#FF8674',
        '#FF5C39',
        '#FA4616',
        '#CF4520',
        '#963821',
        '#6B3529',
      ],
      borderColor: 'transparent',
      pointBackgroundColor: 'orange',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];

  public doughnutChartOptions: any = {
    maintainAspectRatio: false,
    legend: {
      position: 'right'
    },
    responsive: true,
  };

  paymentTypeStyle(sale_type) {
    if (sale_type == 'getnet') {
      let cssClasses = {
        'mb-0': true,
        'text-santander': true,
      }
      return cssClasses;
    } else if (sale_type == 'getnet_top') {
      let cssClasses = {
        'mb-0': true,
        'text-santander': true,
      }
      return cssClasses;
    } else if (sale_type == 'comerciaglobalpay') {
      let cssClasses = {
        'mb-0': true,
        'text-caixabank': true,
      }
      return cssClasses;
    } else if (sale_type == 'comerciaglobalpay_top') {
      let cssClasses = {
        'mb-0': true,
        'text-caixabank': true,
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'mb-0': true,
        'text-muted': true,
      }
      return cssClasses;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/analytics/analytics-realtime/analytics-realtime.ts